export const resolutionFullHD = 1920;
export const fontFamily = '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif';

// AWS S3 caches files for 30days, and CORS settings were not applied when we launched the contest.
// Since there is no manual way of invalidating S3 buckets we add an argument to the end of every file url.
// This can probably be removed after 20th June 2016.
export const bustCacheArg = 'plectov=contest';
